var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import { Tooltip as RsTooltip, UncontrolledTooltip as RsUncontrolledTooltip, } from 'reactstrap';
import classNames from 'classnames';
export const Tooltip = (_a) => {
    var { innerClassName, textAlign = 'left' } = _a, props = __rest(_a, ["innerClassName", "textAlign"]);
    const isNeedRender = useRef(true);
    useEffect(() => {
        if (!props.target || (typeof props.target === 'string' && !document.getElementById(props.target))) {
            console.error('Target for tooltip not found', props.target);
            isNeedRender.current = false;
        }
    }, []);
    if (!isNeedRender.current)
        return null;
    return props.toggle ? (React.createElement(RsTooltip, Object.assign({ innerClassName: classNames(innerClassName, {
            'text-left': textAlign === 'left',
            'text-right': textAlign === 'right',
        }) }, props), props.children)) : (React.createElement(RsUncontrolledTooltip, Object.assign({ innerClassName: classNames(innerClassName, {
            'text-left': textAlign === 'left',
            'text-right': textAlign === 'right',
        }) }, props), props.children));
};
